module.exports = __webpack_public_path__ + "static/media/tourney_create.b7b1be52.png";